export const profileData = {
  name: "CA. Sanjay Kumar Agrawal",
  tagline: "Chartered Accountant | Cost Accountant | Insolvency Professional | Law Graduate",
  experience: "30+ years",
  email: "sanjay@dsrvindia.com",
  phone: "9810116321",
  description: "CA. Sanjay Kumar Agrawal is a senior finance and tax professional with over 30 years of experience in Direct Tax, International Taxation, Transfer Pricing, FEMA and Goods and Services Tax (GST) advisory and litigation.",
  heroImage: "https://cdn.pixabay.com/photo/2021/03/17/04/38/casanjay-6101491_1280.jpg",
  aboutImage: "https://cdn.pixabay.com/photo/2021/03/25/05/05/intelligent-6122006_1280.jpg",
  location: "Gurugram, India",
  website: "https://www.dsrvindia.com"
};

export const qualifications = [
  {
    id: 1,
    title: "Chartered Accountant",
    institution: "Institute of Chartered Accountants of India (ICAI)",
    description: "Professional certification in accounting and taxation"
  },
  {
    id: 2,
    title: "Cost Accountant",
    institution: "Institute of Cost Accountants of India",
    description: "Specialized in cost and management accounting"
  },
  {
    id: 3,
    title: "Insolvency Professional",
    institution: "Insolvency and Bankruptcy Board of India",
    description: "Certified to handle insolvency and bankruptcy matters"
  },
  {
    id: 4,
    title: "Law Graduate",
    institution: "Delhi University",
    description: "Bachelor of Laws degree"
  },
  {
    id: 5,
    title: "Commerce Graduate",
    institution: "Delhi University",
    description: "Bachelor of Commerce degree"
  },
  {
    id: 6,
    title: "Diploma in Information System Audit",
    institution: "ICAI",
    description: "Specialized training in IS audit"
  },
  {
    id: 7,
    title: "International Taxation Certification",
    institution: "ICAI",
    description: "Advanced certification in international tax matters"
  },
  {
    id: 8,
    title: "GST Certification",
    institution: "ICAI",
    description: "Specialized certification in Goods and Services Tax"
  }
];

export const expertise = [
  {
    id: 1,
    title: "GST Advisory & Compliance",
    description: "Comprehensive GST advisory, compliance, audits and litigation services",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Cross-Border GST",
    description: "GST on domestic and cross-border transactions",
    icon: "Globe"
  },
  {
    id: 3,
    title: "GST Supply Chain Structuring",
    description: "GST structuring for complex supply chains",
    icon: "Network"
  },
  {
    id: 4,
    title: "Transfer Pricing",
    description: "Transfer Pricing planning and compliances",
    icon: "TrendingUp"
  },
  {
    id: 5,
    title: "International Taxation",
    description: "International Taxation and Cross-border Structuring",
    icon: "Plane"
  },
  {
    id: 6,
    title: "Non-Resident Taxation",
    description: "Non-Resident and Expatriate Taxation services",
    icon: "Users"
  },
  {
    id: 7,
    title: "PE Risk Advisory",
    description: "Permanent Establishment (PE) risk advisory",
    icon: "AlertTriangle"
  },
  {
    id: 8,
    title: "FEMA Advisory",
    description: "FEMA advisory and regulatory compliances",
    icon: "Scale"
  },
  {
    id: 9,
    title: "Cross-Border M&A",
    description: "Cross-border mergers, acquisitions and restructuring",
    icon: "Briefcase"
  },
  {
    id: 10,
    title: "Inheritance & Succession",
    description: "Cross-border inheritance and succession planning",
    icon: "Home"
  },
  {
    id: 11,
    title: "SEZ & IFSC Advisory",
    description: "Special Economic Zone and International Financial Services Centre advisory",
    icon: "MapPin"
  },
  {
    id: 12,
    title: "Tax Litigation",
    description: "Litigation under GST, International Tax, TP, PMLA, Benami and Black Money Act",
    icon: "Gavel"
  }
];

export const technicalSkills = [
  "Block Chain Technology",
  "Artificial Intelligence",
  "Oracle Applications Implementation Masters (Financials)",
  "Information System Audit"
];

export const contributions = [
  {
    id: 1,
    title: "Professional Speaker",
    description: "Regular speaker at seminars, workshops and conferences organised by ICAI, corporates and industry associations",
    year: "Ongoing"
  },
  {
    id: 2,
    title: "GST Faculty",
    description: "Conducting GST training sessions for members of ICAI & other professional Institutes, focusing on practical interpretation of GST law, audit and investigation issues",
    year: "Ongoing"
  },
  {
    id: 3,
    title: "Chairman, ICAI Gurugram Branch",
    description: "Led the Gurugram Branch of ICAI as Chairman",
    year: "2005-2006"
  },
  {
    id: 4,
    title: "ICAI Leadership",
    description: "Served the Gurugram Branch of ICAI in various leadership roles",
    year: "9 years"
  }
];

export const blogs = [
  {
    id: 1,
    title: "Understanding GST on Cross-Border E-commerce Transactions",
    excerpt: "A comprehensive guide to GST implications for businesses engaged in international e-commerce, covering OIDAR services, place of supply rules, and compliance requirements.",
    date: "2025-02-15",
    category: "GST",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80"
  },
  {
    id: 2,
    title: "Transfer Pricing Documentation: Best Practices for 2025",
    excerpt: "Essential strategies for maintaining compliant transfer pricing documentation, including master file and local file requirements, benchmarking studies, and recent regulatory updates.",
    date: "2025-02-08",
    category: "Transfer Pricing",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80"
  },
  {
    id: 3,
    title: "Permanent Establishment Risks in the Digital Economy",
    excerpt: "Navigating PE risks in the age of digital business models, remote working arrangements, and the impact of OECD BEPS Action Plan on Indian tax compliance.",
    date: "2025-01-28",
    category: "International Tax",
    readTime: "12 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
  },
  {
    id: 4,
    title: "FEMA Compliance for Startups: A Complete Guide",
    excerpt: "Understanding FEMA regulations for startups raising foreign investment, including ECB norms, FDI routes, and reporting obligations to RBI.",
    date: "2025-01-15",
    category: "FEMA",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=800&q=80"
  },
  {
    id: 5,
    title: "Input Tax Credit Optimization Strategies Under GST",
    excerpt: "Practical approaches to maximize ITC claims while ensuring compliance, covering common pitfalls, blocking provisions, and recent judicial precedents.",
    date: "2025-01-05",
    category: "GST",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=800&q=80"
  },
  {
    id: 6,
    title: "Tax Treaty Benefits and MAP Proceedings in India",
    excerpt: "How to claim tax treaty benefits effectively and navigate Mutual Agreement Procedures for resolving international tax disputes.",
    date: "2024-12-20",
    category: "International Tax",
    readTime: "11 min read",
    image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=800&q=80"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What services do you offer for GST compliance?",
    answer: "I provide comprehensive GST services including registration, return filing, GST audits, input tax credit reconciliation, refund claims, advisory on complex transactions, GST litigation support, and representation before tax authorities. My services cover both domestic and cross-border GST matters."
  },
  {
    id: 2,
    question: "How can you help with international taxation matters?",
    answer: "I offer expert guidance on international tax structuring, cross-border transactions, expatriate taxation, Permanent Establishment (PE) risk assessment, tax treaty optimization, transfer pricing compliance, withholding tax matters, and assistance with Advance Pricing Agreements (APAs) and Mutual Agreement Procedures (MAP)."
  },
  {
    id: 3,
    question: "What is your experience with Transfer Pricing?",
    answer: "With over 30 years of experience, I specialize in transfer pricing documentation (master file and local file), benchmarking studies, TP audits and assessments, APA negotiations, MAP proceedings, and defense strategies for transfer pricing litigation. I've handled complex cases across various industries."
  },
  {
    id: 4,
    question: "Do you provide services for FEMA compliance?",
    answer: "Yes, I provide comprehensive FEMA advisory services including foreign investment structuring, ECB compliance, overseas investment advisory, foreign collaboration agreements, repatriation planning, RBI reporting and compliance, and representation in FEMA investigations and adjudication proceedings."
  },
  {
    id: 5,
    question: "Can you assist with tax litigation matters?",
    answer: "Absolutely. I have extensive experience in tax litigation under GST, Income Tax, Transfer Pricing, FEMA, PMLA, Benami Property Act, and Black Money Act. I provide representation before tax authorities, appellate tribunals, High Courts, and Supreme Court, along with comprehensive litigation strategy and support."
  },
  {
    id: 6,
    question: "What makes your approach to tax advisory unique?",
    answer: "My unique combination of qualifications (CA, CMA, IP, Law Graduate) along with expertise in cutting-edge technologies like Blockchain and AI enables me to provide holistic, future-ready tax solutions. I focus on practical, compliant strategies backed by 30+ years of hands-on experience."
  },
  {
    id: 7,
    question: "Do you conduct training sessions on GST and taxation?",
    answer: "Yes, I regularly conduct GST training sessions for ICAI members and corporate professionals. My sessions cover practical interpretation of GST law, audit and investigation issues, cross-border GST matters, recent judicial developments, and industry-specific compliance challenges."
  },
  {
    id: 8,
    question: "How do you charge for your services?",
    answer: "My fee structure varies based on the nature and complexity of services required. I offer flexible arrangements including fixed fees for specific projects, retainer-based arrangements for ongoing compliance, and hourly billing for advisory services. Please contact me for a customized proposal."
  }
];

export const podcasts = [
  {
    id: 1,
    title: "GST on Digital Services: What Businesses Need to Know",
    description: "In this episode, we discuss the GST implications for digital service providers, including OIDAR services, place of supply determination, and recent regulatory changes affecting the digital economy.",
    duration: "32:45",
    date: "2025-02-10",
    category: "GST",
    audioUrl: "#",
    image: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=400&q=80"
  },
  {
    id: 2,
    title: "Transfer Pricing in Post-BEPS Era: Key Insights",
    description: "A deep dive into how BEPS recommendations have reshaped transfer pricing practices in India, covering Country-by-Country Reporting, Master File requirements, and the changing landscape of TP audits.",
    duration: "38:20",
    date: "2025-01-25",
    category: "Transfer Pricing",
    audioUrl: "#",
    image: "https://images.unsplash.com/photo-1590650153855-d9e808231d41?w=400&q=80"
  },
  {
    id: 3,
    title: "Navigating FEMA Regulations for Foreign Investments",
    description: "Expert insights on FEMA compliance for businesses receiving foreign investment, covering FDI routes, ODI norms, ECB guidelines, and common pitfalls to avoid.",
    duration: "29:15",
    date: "2025-01-12",
    category: "FEMA",
    audioUrl: "#",
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&q=80"
  },
  {
    id: 4,
    title: "Tax Treaty Benefits: Maximizing Value for Your Business",
    description: "Learn how to effectively claim tax treaty benefits, understand limitation of benefits provisions, and navigate the Certificate of Residence process for cross-border transactions.",
    duration: "35:50",
    date: "2024-12-28",
    category: "International Tax",
    audioUrl: "#",
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&q=80"
  },
  {
    id: 5,
    title: "GST Audit Insights: What Assessors Look For",
    description: "Based on my experience conducting GST training for ICAI, I share what GST auditors focus on during assessments, common issues identified, and how to prepare your business for GST audits.",
    duration: "27:30",
    date: "2024-12-15",
    category: "GST",
    audioUrl: "#",
    image: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=400&q=80"
  },
  {
    id: 6,
    title: "Blockchain and AI in Tax Compliance: The Future",
    description: "Exploring how emerging technologies like Blockchain and Artificial Intelligence are transforming tax compliance, audit trails, and regulatory reporting in India.",
    duration: "41:10",
    date: "2024-12-01",
    category: "Technology",
    audioUrl: "#",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=400&q=80"
  }
];